import { create } from '@storybook/theming';
import logo from '../src/stories/assets/logo.svg';

export default create({
  base: 'light',

  colorSecondary: '#0067b9',

  // Typography
  fontBase: '"Inter", sans-serif',
  fontCode: 'monospace',

  // UI
  appBg: '#f1f5f9',
  appContentBg: 'white',

  // Text colors
  textColor: '#212836',

  brandImage: logo,

});
